<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
	.tag-btn {
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>订单管理</el-breadcrumb-item>
			<el-breadcrumb-item>发单列表</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="box">
			<div style="margin-left: 20px; display: flex; flex-direction: row; align-items: center;">
				<div>彩种：</div>
				<el-select size="mini" v-model="search.gameType" placeholder="全部类型" style="width: 120px;">
					<el-option label="全部" value=""></el-option>
					<el-option label="竞彩足球" value="football"></el-option>
					<el-option label="竞彩篮球" value="basketball"></el-option>
					<el-option label="北京单场" value="peking"></el-option>
				</el-select>
				<div>&nbsp;&nbsp;订单状态：</div>
				<el-select size="mini" v-model="search.status" placeholder="全部类型" style="width: 120px;">
					<el-option label="全部" :value="-1"></el-option>
					<el-option label="待接单" :value="0"></el-option>
					<el-option label="待出票" :value="1"></el-option>
					<el-option label="待开奖" :value="2"></el-option>
					<el-option label="已中奖" :value="3"></el-option>
					<el-option label="未中奖" :value="4"></el-option>
					<el-option label="已派奖" :value="5"></el-option>
					<el-option label="已撤单" :value="6"></el-option>
					<el-option label="已取票" :value="7"></el-option>
				</el-select>
				<div>&nbsp;&nbsp;搜索：</div>
				<el-input size="mini" placeholder="订单号 / ORID / UID / SID" v-model="search.keyword" style="margin-right: 10px; width:280px;"></el-input>
				<el-button size="mini" type="primary" @click="getData()">搜索</el-button>
				<el-button size="mini" type="warning" @click="reset()">重置</el-button>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="orid" label="订单号" align="center" width="160">
					<template slot-scope="scope">
						{{scope.row.orderSn}}
					</template>
				</el-table-column>
				<el-table-column prop="sid" label="发单店铺" align="center" width="160">
					<template slot-scope="scope">
						{{scope.row.shop_name}}<span style="color: #999999;">({{scope.row.sid}})</span>
					</template>
				</el-table-column>
				<el-table-column prop="uid" label="UID" align="center" width="80">
				</el-table-column>
				<el-table-column prop="user_nickname" label="会员账号" align="center" width="120">
				</el-table-column>
				<el-table-column prop="user_username" label="会员昵称" align="center"  width="120">
				</el-table-column>
				<el-table-column prop="lotteryName" label="彩种" align="center" width="100">
				</el-table-column>
				<el-table-column prop="total_money" label="跟单人数" align="center" width="80">
					<template slot-scope="scope">
						{{scope.row.follow_numer}}人
					</template>
				</el-table-column>
				<el-table-column prop="total_money" label="跟单金额" align="center" width="80">
					<template slot-scope="scope">
						{{scope.row.follow_amount}}元
					</template>
				</el-table-column>
				
				<el-table-column prop="total_money" label="截止" align="center" width="140">
					<template slot-scope="scope">
						
						<el-tag type="danger" v-if="getStopStatus(scope.row.shopStopTime)==0" size="mini">已截止</el-tag>
						<el-tag type="success" v-else size="mini">{{getStopStatus(scope.row.shopStopTime)}}截止</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="orderStatus" label="状态" align="center" width="100">
					<template slot-scope="scope">
						<el-tag type="info" v-if="scope.row.orderStatus==0" size="mini">待接单</el-tag>
						<el-tag type="info" v-if="scope.row.orderStatus==1" size="mini">待出票</el-tag>
						<el-tag type="success" v-if="scope.row.orderStatus==2" size="mini">待开奖</el-tag>
						<el-tag type="danger" v-if="scope.row.orderStatus==3" size="mini">已中奖</el-tag>
						<el-tag type="primary" v-if="scope.row.orderStatus==4" size="mini">未中奖</el-tag>
						<el-tag type="danger" v-if="scope.row.orderStatus==5" size="mini">已派奖</el-tag>
						<el-tag type="info" v-if="scope.row.orderStatus==6" size="mini">已撤单</el-tag>
						<el-tag type="primary" v-if="scope.row.orderStatus==7" size="mini">已取票</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="recommend" label="推荐" align="center" width="100">
					<template slot-scope="scope">
						<span type="info" v-if="scope.row.recommend==0" size="mini">-</span>
						<el-tag type="danger" v-if="scope.row.recommend==1" size="mini">推荐</el-tag>
						<el-tag type="primary" v-if="scope.row.recommend==2" size="mini">精选</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="total_money" label="自购订单" align="center" width="120">
					<template slot-scope="scope">
						{{scope.row.orderAmount}}元
					</template>
				</el-table-column>
				<el-table-column prop="award" label="中奖金额" align="center" width="120">
					<template slot-scope="scope">
						<span style="color: red;" v-if="scope.row.orderStatus == 5 || scope.row.orderStatus == 3">{{scope.row.award}}元</span>
						<span v-else>-</span>
					</template>
				</el-table-column>
				
				<el-table-column prop="downTime" label="发单时间" align="center"  width="180">
					<template slot-scope="scope">
						{{formatTimestamp(scope.row.downTime)}}
					</template>
				</el-table-column>
				
				
				<el-table-column prop="status" label="操作" fixed="right" width="260" align="center">
					<template slot-scope="scope">
						<el-tag class='tag-btn' style="margin-right: 10px;" size="mini"  @click="viewOrder(scope)">订单详情</el-tag>
						<el-tag class='tag-btn' style="margin-right: 10px;" type="danger" size="mini"  @click="popularOrder(scope)">添加人气</el-tag>
						<el-tag class='tag-btn' style="margin-right: 10px;" type="warning" size="mini"  @click="HideOrder(scope)">隐藏订单</el-tag>
						<el-tag slot="reference" class='tag-btn'type="success" style="margin-right: 10px;" size="mini" @click="remOrder(scope, 1)">每日推荐</el-tag>
						<el-tag slot="reference" class='tag-btn'type="success" style="margin-right: 10px;" size="mini" @click="remOrder(scope, 2)">精选2串1</el-tag>
						<el-tag slot="reference" class='tag-btn'type="success" style="margin-right: 10px;" size="mini" @click="remOrder(scope, 0)">取消推荐</el-tag>
					</template>
				</el-table-column>
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[9, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		
		<el-dialog style="-webkit-app-region:no-drag;" title="订单详情" v-if="detailShow" :visible.sync="detailShow"  width="580px" draggable align-center :before-close="closeShow">
			<orderDetail :orid="viewOrid" :closeFunc="closeShow"></orderDetail>
		</el-dialog>
		
		<el-dialog style="-webkit-app-region:no-drag;" v-if="popularShow"  top="30px" :visible.sync="popularShow"  width="1400px" draggable align-center :before-close="closeShow">
			<followPopular :fid="viewOrid" :closeFunc="closeShow"></followPopular>
		</el-dialog>
		
	</div> 
</template>

<script>
	
	import orderDetail from './orderDetail.vue';
	import followPopular from '../virtual/followPopular.vue';
	export default {
		components: {
			orderDetail, followPopular
		},  
		computed:{
		},
		data(){
			return {
				search:{
					keyword:'',
					status:-1,
					gameType:'',
				},
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:9,
				detailShow:false,
				popularShow:false,
				viewOrid:0,
			}
		},
		created() {
			this.getData();
		},
		methods:{
			getStopStatus(_t){
				let tTime = _t * 1000;
				let nTime = new Date().getTime();
				if(tTime > nTime){
					return this.stopTime(tTime);
				}else{
					return 0;
				}
			},
			remOrder(scope, _recommend){
				console.log(scope);
				let that = this;
				that.loading = true;
				that.$api.post("/Order/changeOrderRecommend", {fid:scope.row.fid, recommend:_recommend}).then(res=>{
					that.loading = false;
					if(res.code == 200){
						scope.row.recommend = _recommend;
					}else{
						that.$message({ message: '操作失败', type: 'success', });
					}
				}).catch(res=>{
					that.loading = false;
				}); 
			},
			popularOrder(scope){
				this.viewOrid = scope.row.fid;
				this.popularShow = true;
			},
			HideOrderApi(scope){
				let _this = this;
				_this.loading = true;
				_this.$api.post("/Order/HideFollowOrder", {orid:scope.row.orid}).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.tableData.splice(scope.$index, 1);
						_this.$message({ message: '隐藏成功', type: 'success', });
					}else{
						_this.$message({ message: '隐藏失败', type: 'warning', });
					}
				}).catch(res=>{
					_this.loading = false;
				});
			},
			HideOrder(scope){
				let _this = this;
				this.$confirm('是否确认隐藏此订单？隐藏后，不可再次显示', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.HideOrderApi(scope);
				}).catch(() => {      
				});
			},
			viewOrder(scope){
				this.viewOrid = scope.row.orid;
				this.detailShow = true;
			},
			closeShow(){
				this.detailShow = false;
				this.popularShow = false;
			},
			deleteApi(scope){
				let _this = this;
				_this.loading = true;
				_this.$api.post("/Order/deleteOrder", {orid:scope.row.orid}).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.tableData.splice(scope.$index, 1);
						_this.$message({ message: '删除成功', type: 'success', });
					}else{
						_this.$message({ message: '删除失败', type: 'warning', });
					}
				}).catch(res=>{
					_this.loading = false;
				});
			},
			deleteFunc(scope){
				let _this = this;
				this.$confirm('是否确认删除此订单？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.deleteApi(scope);
				}).catch(() => {      
				});
			},
			reset(){
				this.search = {
					keyword:'',
					status:'99',
					gameType:'99'
				}
				this.getData();
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/Order/getFollowOrderList", {page:this.currentPage, limit:this.limit, ...this.search}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			},
			formatTimestamp(ts) {
				if(ts == 0){
					return '';
				}
				// 如果是 10 位（秒），需要乘 1000 变成毫秒
				if (ts.toString().length === 10) {
					ts *= 1000
				}
				const date = new Date(ts)
			
				const Y = date.getFullYear()
				const M = String(date.getMonth() + 1).padStart(2, '0')
				const D = String(date.getDate()).padStart(2, '0')
			
				const h = String(date.getHours()).padStart(2, '0')
				const m = String(date.getMinutes()).padStart(2, '0')
				const s = String(date.getSeconds()).padStart(2, '0')
			
				return `${Y}-${M}-${D} ${h}:${m}:${s}`
			},
			stopTime(ts) {
				if(ts == 0){
					return '';
				}
				// 如果是 10 位（秒），需要乘 1000 变成毫秒
				if (ts.toString().length === 10) {
					ts *= 1000
				}
				const date = new Date(ts)
			
				const Y = date.getFullYear()
				const M = String(date.getMonth() + 1).padStart(2, '0')
				const D = String(date.getDate()).padStart(2, '0')
			
				const h = String(date.getHours()).padStart(2, '0')
				const m = String(date.getMinutes()).padStart(2, '0')
				const s = String(date.getSeconds()).padStart(2, '0')
			
				return `${M}-${D} ${h}:${m}`
			},
		}
	}
</script>

